import parse from "html-react-parser";

const PrintHTML = ({ text }) => {
  return <p> {text && parse(text)}</p>;
};

export default PrintHTML;
